import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import PatientSectionWrapper from "./PatientSectionWrapper";
import {
  AppointmentProvider,
  useAppointmentContext,
} from "./appointment/context/AppointmentContext";

const PatientPortalAppointmentContent = () => {
  const { setAppointments, setIsLoading } = useAppointmentContext();

  useEffect(() => {
    // Simulate loading state
    setIsLoading(true);
    const timer = setTimeout(() => {
      // Initialize with dummy data
      setAppointments([]);
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [setAppointments, setIsLoading]);

  return (
    <PatientSectionWrapper>
      <Outlet />
    </PatientSectionWrapper>
  );
};

const PatientPortalAppointment = () => {
  return (
    <AppointmentProvider>
      <PatientPortalAppointmentContent />
    </AppointmentProvider>
  );
};

export default PatientPortalAppointment;
